import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import anfitriaImg from '../images/anfitria.jpeg';

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <h2>Sua Anfitriã</h2>
      
      <div className="host-container">
        <div className="host-image-wrapper">
          <img src={anfitriaImg} alt="Tereza, anfitriã" className="host-image" />
        </div>
        <div className="host-text">
          <h3>Olá, eu sou a Tereza!</h3>
          <p>Estou à disposição para personalizar sua reserva e garantir dias incríveis nas montanhas. Acompanhe nosso dia a dia e novidades exclusivas de cada chalé no Instagram:</p>
          
          <div className="instagram-links">
            <a href="https://www.instagram.com/chalecristalsbs/" target="_blank" rel="noopener noreferrer" className="insta-btn">
              <FaInstagram /> Chalé Cristal
            </a>
            <a href="https://www.instagram.com/chalesafira/" target="_blank" rel="noopener noreferrer" className="insta-btn">
              <FaInstagram /> Chalé Safira
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
